<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <nav
    ref="flyoutNav"
    tabindex="-1"
    :style="styles"
    :aria-label="linkGroup.label"
    @mouseleave="closeOptions"
    @focusin="onFocusIn"
    @focusout="onFocusOut"
  >
    <button
      aria-haspopup="listbox"
      class="navigation-flyout-trigger"
      :class="{ '-is-open': isOpen }"
      data-testid="navigation-group-desktop"
      @mouseover="showOptions"
      @focus="onButtonFocus"
    >
      <span>{{ linkGroup.label }}</span>
      <Icon
        icon="fa6-solid:chevron-down"
        data-icon="fa6-solid:chevron-down"
        width="10"
        height="10"
      />
    </button>
    <ul
      v-show="isOpen"
      ref="options"
      tabindex="-1"
      class="navigation-flyout-options"
      role="listbox"
    >
      <li
        v-for="(link, index) in linkGroup.links"
        :key="link.label + '-' + index"
        @keydown.down.prevent="focusNextItem(index)"
        @keydown.up.prevent="focusPrevItem(index)"
        @keydown.esc.prevent="close"
      >
        <a
          class="navigation-flyout-option"
          :href="link.url"
          data-testid="navigation-sublink-desktop"
          @click="$emit('emittedClick', { type: 'link', el: link })"
        >
          <span>{{ link.label }}</span>
          <Icon
            icon="fa6-solid:arrow-right"
            data-icon="fa6-solid:arrow-right"
            width="12"
            height="12"
          />
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { Icon } from "@iconify/vue";
import { flyoutMixins } from "./flyoutMixins.js";

export default {
  name: "NavigationUIFlyout",
  components: {
    Icon,
  },
  mixins: [flyoutMixins],
  props: {
    linkGroup: {
      type: Object,
      required: true,
    },
  },
  emits: ["emittedClick"],
  data() {
    return {
      isOpen: false,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "./flyout.scss";
</style>
